import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(value) {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return formatDate(value);
  return (
    d.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    ", " +
    d.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" })
  );
}

export const PACKAGING_SHORT = {
  "120x80": "Euro 120×80",
  "120x110": "Industrie 120×110",
  "160x80": "Gross 160×80",
  "110x80": "Halbpal. 110×80",
  "60x80": "Halbpal. 60×80",
  efz_2rad: "E-Fahrzeug 2 Rad",
  efz_3rad: "E-Fahrzeug 3 Rad",
  efz_4rad: "E-Fahrzeug 4 Rad",
};
export const packagingLabel = (code) => PACKAGING_SHORT[code] || code || "";
